module.exports = __webpack_public_path__ + "img/icono-edu.c923223d.svg";